<template>
  <div class="fill-height d-flex flex-column">
    <div class="flex-grow-1 overflow-hidden">
      <draggable-group-list
        ref="layerGroup"
        class="overflow-auto"
        :items.sync="itemsLayerGroup"
        :selected.sync="itemsLayerSelect"
        :groupShow.sync="isGroupShow"
        @click:drag-done="updateLayer()"
        @click:remove-group="onDeleteGroup"
        :disabled="disabled"
        :readonly="readonly"
        :disabledDrag="readonly"
      >
        <template #item="props">
          <slot name="item" v-bind="props"> </slot>
        </template>
        <template #extra-btn-item-group="props">
          <slot name="extra-btn-item-group" v-bind="props"> </slot>
        </template>
      </draggable-group-list>
    </div>
  </div>
</template>

<script>
import { DraggableGroupList } from '@components/draggable'
export default {
  components: {
    DraggableGroupList,
  },
  props: {
    layers: { type: Array, required: true },
    disabled: Boolean,
    selected: { type: Array, default: () => [] },
    readonly: Boolean,
  },
  data: () => ({ itemsLayerGroup: [], isGroupShow: {} }),
  watch: {
    layers: {
      handler(value) {
        let treeLayer = []
        if (value && value.length > 0) {
          value.forEach((x) => {
            if (!x.group) {
              treeLayer.push(x)
              return
            }
            let group = treeLayer.find((group) => group.id == x.group.id)
            if (
              !Object.prototype.hasOwnProperty.call(
                this.isGroupShow,
                x.group.id
              )
            ) {
              this.isGroupShow[x.group.id] = true
            }
            if (group) {
              group.children.push(x)
            } else {
              treeLayer.push({
                ...x.group,
                children: [x],
                show: true,
                isGroup: true,
                show_layer_map: true,
              })
            }
          })
        }
        this.itemsLayerGroup = treeLayer
      },
      immediate: true,
    },
  },
  computed: {
    itemsLayerSelect: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
  },
  methods: {
    onDeleteGroup(group) {
      this.$emit('click:delete-group', group)
      this.updateLayer()
    },
    addNewGroup() {
      this.$refs.layerGroup.addSelectToNewGroup()
    },
    onAddLayer(layer) {
      this.itemsLayerGroup.unshift(layer)
      this.updateLayer()
    },
    updateLayer() {
      let layers = this.itemsLayerGroup.reduce((acc, cur) => {
        if (cur.isGroup) {
          if (cur.children.length > 0) {
            acc.push(
              ...cur.children.map((x) => {
                x.group = { id: cur.id, name: cur.name }
                return x
              })
            )
          }
        } else {
          cur.group = undefined
          acc.push(cur)
        }
        return acc
      }, [])

      this.$emit('update:layers', layers)
    },
    onDeleteLayer(layer, group) {
      let layers = this.layers
      this.$emit('layer:action', { type: 'delete', layer })

      let index = layers.findIndex((x) => x.id == layer.id)
      if (index < 0) {
        return
      }
      layers.splice(index, 1)

      this.$emit('update:layers', layers)
    },
    onCallActionLayer({ type, data: layer, ...rest } = {}) {
      this.$emit('layer:action', { type, layer, ...rest })
    },
    onUpdateLayer(layer) {
      this.$emit('layer:action', { type: 'update', layer })
    },
    toggleGroupShow(group) {
      group.show = !group.show
      group.children = group.children.map((x) => {
        x.show = group.show
        this.$emit('update:layer', x)
        return x
      })
    },
  },
}
</script>

<style scoped></style>
